export default "__VITE_ASSET__T2EL55Vc__"